<script>
  import ByPersonTrendChart from './ByPersonTrendChart.vue';

  export default {
    name: 'NewRevenueTrends',
    extends: ByPersonTrendChart,
    data() {
      return {
        chartId: 'netRevenueTrends',
        propertyName: 'net_ha_revenue',
        propertyNamePerson: 'net_hearing_aid_revenue',
        label: 'Net Revenue',
        curYearColor: '#6EA7E2',
        prevYearColor: '#F6682F',
      };
    },
  };
</script>
